import React, { Component } from "react";
import dayjs from "dayjs";
import "dayjs/locale/nl";
import { connect } from "react-redux";
import { hideOrderModal } from "../../../redux/actions/miscActions";
import { updateOrderStatus, archiveOrder, downloadPdf } from "../../../redux/actions/orderActions";
import { Modal, Badge, Select, Popconfirm, message } from "antd";

const { Option } = Select;
dayjs.locale("nl");

export class Order extends Component {
  constructor(props){
    super(props);
    this.state={
      orderStatus: ''
    }
  }
  
  
  handleCancel = () => {
    this.props.hideOrderModal();
  };

  handleUpdateStatus=(e)=>{
    const { selOrder } = this.props.misc;
    const { id, updatedStatus } = selOrder
    if(updatedStatus === 'admin'){

      this.setState({
        orderStatus: e.value
      })
    }
    this.props.updateOrderStatus(id, e.value, updatedStatus)
  }

  componentDidUpdate=(prevProps)=>{
    const { status } = this.props.misc.selOrder
    if(prevProps.misc.selOrder !== this.props.misc.selOrder){    
      this.setState({
        orderStatus: status
      })
    }
  }


  handleConfirmArchive=()=>{
    const { selOrder } = this.props.misc;
    const { id } = selOrder
    const { orderStatus } = this.state
    if(orderStatus === 'pending'){
      this.warning()
    } else {
      this.props.archiveOrder(id)
    }
  }

  handleDownloadPdf=()=>{
    const { selOrder } = this.props.misc;
    this.props.downloadPdf(selOrder)
  }

  warning=()=>{
    message.warning('Kan lopende bestelling niet archiveren');
  }

  render() {
    const { isOrderModalVisible, selOrder } = this.props.misc;
    const {
      date,
      orderNumber,
      orderCost,
      deliveryCost,
      cust,
      cart,
      updatedStatus
    } = selOrder;
    const { orderStatus } = this.state
    const orderDetails =
      cart && cart.length > 0
        ? cart.map((x) => {
            return (
              <tr key={x.productNaam + x.pakketNaam}>
                <td>{x.productId.length > 0 ? x.productId : "-"}</td>
                <td>{x.productCategorie === 'pakket' ? x.pakketNaam : x.productNaam}</td>
                <td>{ x.productCategorie === 'pakket' ? '-' : x.productAttributen.toString().split(",").join(" - ")}</td>
                <td>{`${x.quantity} x ${x.productCategorie === 'pakket' ? '' : x.productEenheid}`}</td>
              </tr>
            );
          })
        : "";
    return (
      <div>
        <Modal
          className="order-modal"
          footer={null}
          visible={isOrderModalVisible}
          onCancel={this.handleCancel}
        >
          <div className="order-modal-content">
            <div className="header">
              <h5>Order#: {orderNumber}</h5>

              {orderStatus === "pending" ? (
                  <span>
                    <Badge status="processing" />
                    pending
                  </span>
                ) : orderStatus === 'cancelled' ? (<span>
                  <Badge status="error" />
                  geannuleerd door {updatedStatus}
                </span>) : orderStatus === 'processing' ? (<span>
                  <Badge status="warning" />
                    in behandeling
                </span>) : (
                  <span>
                    <Badge status="success" />
                    afgewerkt
                  </span>
                )}
             
            </div>
            {cust && cust.message && cust.message.length > 0 ? (
              <div className="cust-message">{cust.message}</div>
            ) : null}

            <div className="order-info">
              <div className="order-details">
                {cust ? (
                  <div className="customer-details">
                    <h4>Klant informatie</h4>
                    <p>{cust.name}</p>
                    <p>{`${cust.adress} #${cust.houseNum}`}</p>
                    <p>{
      cust.regio === "PBM"
        ? "Paramaribo"
        : cust.regio === "CM"
        ? "Commewijne"
        : cust.regio === "BR"
        ? "Brokopondo"
        : cust.regio === "WN"
        ? "Wanica"
        : cust.regio === "PR"
        ? "Para"
        : "Buurt niet aangegeven"
    }</p>
                    <p>{cust.email}</p>
                    <p>{cust.phone}</p>
                  </div>
                ) : null}

                {selOrder ? (
                  <div className="bestel-info">
                    <h4>Bestel informatie</h4>
                    <p>
                      Totaal bedrag:{" "}
                      <span>
                        {new Intl.NumberFormat("IN", {
                          style: "currency",
                          currency: "SRD",
                        }).format(`${orderCost}`)}
                      </span>
                    </p>
                    <p>
                      Leverkosten:{" "}
                      <span>
                        {cust.regio === 'PBM' ? new Intl.NumberFormat("IN", {
                          style: "currency",
                          currency: "SRD",
                        }).format(`${deliveryCost}`) : '-'}
                      </span>
                    </p>
                    <p>
                      Datum:{" "}
                      <span>{dayjs(date.toDate()).format("DD MMMM YYYY")}</span>
                    </p>
                  </div>
                ) : null}
              </div>

              <div className="cart-details">
                <h4>Bestelling</h4>
                <table>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Naam</th>
                      <th>Attributen</th>
                      <th>Aantal</th>
                    </tr>
                  </thead>
                  <tbody>{orderDetails}</tbody>
                </table>
              </div>
            </div>
            <div className="order-actions">
              <Select value={{value: orderStatus ? orderStatus.toString() : null}} labelInValue onChange={this.handleUpdateStatus}>
                <Option value="pending">Pending</Option>
                <Option value="processing">In behandeling</Option>
                <Option value="cancelled">Geannuleerd</Option>
                <Option value="done">Afgewerkt</Option>
              </Select>
              <button className="icon-button-lg" onClick={this.handleDownloadPdf}>
                <i className="far fa-file-pdf"></i> Download pdf
              </button>
            </div>
            <div className="archive-order">
            <Popconfirm
                  placement="topLeft"
                  title={`Weet u zeker dat u order# ${orderNumber} wil archiveren?`}
                  onConfirm={this.handleConfirmArchive}
                  okText="Doorgaan"
                  cancelText="Annuleren"
                >
                  <button className="icon-button-lg">
                    <i className="far fa-folder-open"></i> Archiveren
                  </button>
                </Popconfirm>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  misc: state.misc,
});

export default connect(mapStateToProps, { hideOrderModal, updateOrderStatus, archiveOrder, downloadPdf })(Order);
